import styled from "styled-components";

import {
  alignItemsCenter,
  flexCenter,
  flexSpBetween,
  rem,
  size,
} from "@styles/Utilities.styled";


export const StyledCardHeader = styled.div`
  ${flexSpBetween}
  align-items: end;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--clr-gray-175);

  .title {
    font-size: ${rem(18)};
    font-weight: 500;
    line-height: 1.2;
  }

  .btn-wrapper {
    --btn-gap: 0.25rem;

    ${alignItemsCenter}
    gap: var(--btn-gap);
    overflow: hidden;
    isolation: isolate;
  }

  button {
    ${flexCenter}
    ${size(rem(30))}
    border-radius: var(--border-radius-2);
    border: 1px solid var(--clr-gray-175);
    background-color: var(--clr-white);
    transition: transform 0.3s var(--ease-slow-start);

    &:hover {
      background-color: var(--clr-accent);
      border-color: rgb(0, 0, 0, 0);

      svg {
        fill: var(--clr-white);
      }
    }

    &:disabled {
      cursor: not-allowed;
      background-color: var(--clr-gray-100);
      border-color: var(--clr-gray-175);
    }

    &:first-child {
      transform: translateX(calc((100% + var(--btn-gap))));
      z-index: 1;
    }

    &:nth-child(2) {
      &:hover {
        background-color: var(--clr-rose);
      }
    }

    &.disappear {
      transform: translateY(100%);
    }

    &.move {
      transform: translateX(0);
    }

    svg {
      fill: var(--clr-accent);
      ${size("60%")}
      margin-inline: auto;
    }

    .plus-icon {
      ${size("70%")}
    }

    .save-icon {
      ${size("70%")}
    }

    .spinner {
      svg {
        ${size("80%")}
      }
    }

    .close-icon {
      ${size("85%")}
      fill: var(--clr-rose);
    }
  }
`;
